export default {
    get(url, request) {
        return axios.get(url, request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error.response));
    },
    post(url, request) {
        return axios.post(url, request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error.response));
    },
    patch(url, request) {
        return axios.patch(url, request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error.response));
    },
    delete(url, request) {
        return axios.delete(url, request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error.response));
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/utils/api.js